import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
//import { FormsModule } from '@angular/forms';   //is this needed here.  can we/should we export from the app module?
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedPageModule } from '@Work/Accounts/proprietary/pages/shared-page.module';
import { DocumentImportComponent } from './document-import/document-import.component';
import { ExtractAttachmentComponent } from './extract-attachment/extract-attachment.component';

@NgModule({
    imports: [CommonModule, NgbTooltipModule, SharedPageModule],
    declarations: [DocumentImportComponent, ExtractAttachmentComponent],
    providers: [],
    exports: [DocumentImportComponent, ExtractAttachmentComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DocumentImportModule { }
